import { useEffect, useState, useCallback, useRef, forwardRef, useImperativeHandle } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import './ReviewBook.scss'
import { useAcceptJs } from 'react-acceptjs'
import { AddCardPopUp, PopUp, useDetectInternetConnection, useScrollLock } from 'ui_kit_qmd'
import { VisitSummary } from './components/visit-summary/VisitSummary'
import { Payment } from './components/payment/Payment'
import { ViewAllCards } from './components/payment/components/view-all-cards/ViewAllCards'
import { setError, setIsVisitRescheduledSuccess } from '../../../../store/new-visit/NewVisitActions'
import { errorCodes, getUserFriendlyErrorMessage } from '../../../../utils/errormessages'
import { addPatientCreditCard } from '../../../../store/new-visit/NewVisitThunk'
import { text } from './Constants'
import env from '../../../../env.json'
import { RESCHEDULE_VISIT_PAGE_PATH } from '../../../../utils/constants'
import { useInitialPatientInformation } from '../../hooks/useInitalPatientInformation'
import successIcon from '../../../../images/common/success.png'
import { useLocalAdyen } from '../../hooks/useLocalAdyen'
import '@quickmd-llc/design-system/features/adyen/styles.css'

import _ from 'lodash'

export const ReviewBook = forwardRef(
  (
    {
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      bookingId,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      visitInfo,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      selectedPatient,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      show,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      timeZone,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      zoneAbbrString,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      paymentKeys,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      forceLoading,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setPrice,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      methodError,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      priceError,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setCardMethod,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      creditAmount,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setMethodCardError,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      onBookVisitSuccess,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      setSelectedOption,
      // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
      selectedOption,
    },
    ref,
  ) => {
    const { pathname } = useLocation()
    const dispatch = useDispatch()
    const addCardRef = useRef()
    const { lockScroll, unlockScroll } = useScrollLock()

    const {
      patientFullNameInitial,
      dobTextInitial,
      emailTextInitial,
      addressTextInitial,
      phoneNumberTextInitial,
      phoneCountryCodeInitial,
    } = useInitialPatientInformation()

    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const isVisitRescheduledSuccess = useSelector((state) => state.newVisitReducer.isVisitRescheduledSuccess)
    const isReschedulePage = pathname === RESCHEDULE_VISIT_PAGE_PATH

    const cards = useSelector(
      // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
      (state) => state.newVisitReducer.visits[bookingId]?.cards,
      (a, b) => {
        if (a?.length === b?.length) {
          for (let i = 0; i < a?.length; i += 1) {
            if (!_.isEqual(a[i], b[i])) {
              return false
            }
          }
        } else {
          return false
        }
        return true
      },
    )

    const [paymentCard, setPaymentCard] = useState()
    const [cardsList, setCardsList] = useState([])
    const [ignoreDefault, setIgnoreDefault] = useState(false)

    const [showCardsList, setShowCardsList] = useState(false)
    const [showAddPopUp, setShowAddPopUp] = useState(false)
    const [showRescheduleSuccessPopup, setShowRescheduleSuccessPopup] = useState(false)

    const isOnline = useDetectInternetConnection()

    useImperativeHandle(
      ref,
      () => ({
        onAddCardSuccess() {
          setIgnoreDefault(true)
          setShowAddPopUp(false)
          forceLoading(false)
        },
      }),
      [],
    )
    useEffect(() => {
      if (show) {
        setCardMethod(null)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setPaymentCard(null)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setShowCardsList(null)
      }
    }, [show])
    useEffect(() => {
      if (!selectedPatient?.dob) {
        setCardMethod(null)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setPaymentCard(null)
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setShowCardsList(null)
      }
    }, [selectedPatient])

    useEffect(() => {
      if (isVisitRescheduledSuccess) {
        setShowRescheduleSuccessPopup(true)

        setTimeout(() => {
          setShowRescheduleSuccessPopup(false)
          dispatch(setIsVisitRescheduledSuccess())
          onBookVisitSuccess()
        }, 2000)
      }
    }, [isVisitRescheduledSuccess])

    useEffect(() => {
      if (cards?.length) {
        let defaultFound = false
        if (ignoreDefault) {
          const idList = cardsList.map(({ Id }) => Id)
          // you seem to be able to add the same card multiple times, and in that case, there is no "new card" so this
          // errors down the line. in cases like this, just find a card, preferable the currently selected one so at
          // least we don't encounter an error.
          // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
          let newCard = cards.find(({ Id }) => !idList.includes(Id)) ?? cards.find((x) => x.isSelected)
          if (!newCard && cards.length > 0) {
            ;[newCard] = cards
          }
          if (newCard) {
            setPaymentCard({ ...newCard, isSelected: true })
            setCardMethod({ ...newCard, isSelected: true })
          } else {
            // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
            setPaymentCard(null)
            setCardMethod(null)
          }

          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          const newCardsList = cards.map((card) => {
            const currentCard = { ...card }
            if (newCard?.Id === card.Id) {
              currentCard.isSelected = true
            } else {
              currentCard.isSelected = false
            }
            return currentCard
          })
          setIgnoreDefault(false)
          setCardsList(newCardsList)
        } else {
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          const newCardsList = cards.map((card) => {
            const currentCard = { ...card }
            if (currentCard.IsDefault) {
              defaultFound = true
              currentCard.isSelected = true
              setPaymentCard(currentCard)
              setCardMethod(currentCard)
            }
            return currentCard
          })
          if (!defaultFound) {
            newCardsList[0].isSelected = true
            setPaymentCard(newCardsList[0])
            setCardMethod(newCardsList[0])
          }
          setCardsList(newCardsList)
        }
      } else if (cards) {
        // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
        setPaymentCard(null)
        setCardMethod(null)
        setCardsList([])
      }
      if (!show) {
        setCardsList([])
      }
    }, [cards, show])

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onViewCards = useCallback((value) => {
      setShowCardsList(value)
    }, [])

    const onAddPaymentClick = useCallback(() => {
      setShowCardsList(false)
      setShowAddPopUp(true)
      lockScroll()
    }, [lockScroll])

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onSelectCard = useCallback((card) => {
      setPaymentCard(card)
      setCardMethod(card)

      // @ts-expect-error TS2345 -- MIGRATION: not approved, fix when encountered
      setCardsList((currentCards) => {
        const newList = currentCards.map((currentCard) => {
          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
          if (card.Id === currentCard.Id) {
            // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
            return { ...currentCard, isSelected: true }
          }
          // @ts-expect-error TS2698 -- MIGRATION: not approved, fix when encountered
          return { ...currentCard, isSelected: false }
        })
        return newList
      })
      setShowCardsList(false)
    }, [])

    // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
    const onSetPaymentError = useCallback((code, msg) => {
      switch (code) {
        case 'fill all':
          dispatch(setError(getUserFriendlyErrorMessage(errorCodes.FILL_ALL_FIELDS), bookingId))
          break
        case 'exact':
          dispatch(setError(msg, bookingId))
          break
        case 'no connection':
          dispatch(setError(getUserFriendlyErrorMessage(errorCodes.NO_CONNECTION), bookingId))
          break
        default:
      }
    }, [])
    const authData = {
      apiLoginID: paymentKeys.ApiLoginId,
      clientKey: paymentKeys.ClientKey,
    }
    const { dispatchData } = useAcceptJs({
      // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
      environment: paymentKeys.AcceptJsUrl === text.ACCEPT_TEST_URL ? text.SANDBOX : text.PRODUCTION,
      authData,
    })

    const onGetUserFriendlyMessage = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (code, type) => {
        switch (code) {
          case 'required field':
            // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
            addCardRef.current.onSetLocalMsg(getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, type), type)
            break
          case 'invalid item':
          case 'enter valid':
            // @ts-expect-error TS18048 -- MIGRATION: not approved, fix when encountered
            addCardRef.current.onSetLocalMsg(getUserFriendlyErrorMessage(errorCodes.ENTER_VALID, null, type), type)
            break
          case 'no connection':
            dispatch(setError(getUserFriendlyErrorMessage(errorCodes.NO_CONNECTION), bookingId))
            break
          default:
        }
      },
      [bookingId, dispatch],
    )

    const { adyen } = useLocalAdyen()

    const onAddCreditCard = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      async (address, isDefault, cardData) => {
        setMethodCardError('')
        const adyenEncryptedMetadata = await adyen?.getAdyenEncryptedData()

        if (adyen) forceLoading(true)
        try {
          let body = {
            Address: address,
            IsDefault: isDefault,
          }
          if (adyenEncryptedMetadata) {
            body = {
              ...body,
              ...adyenEncryptedMetadata,
            }
          } else {
            const response = await dispatchData({
              cardData,
            })
            const { opaqueData } = response
            const { dataDescriptor, dataValue } = opaqueData
            body = {
              ...body,
              // @ts-expect-error TS2353 -- MIGRATION: not approved, fix when encountered
              DataValue: dataValue,
              DataDescriptor: dataDescriptor,
            }
          }

          dispatch(addPatientCreditCard(selectedPatient.PatientId, bookingId, body, adyen))
        } catch (e) {
          let errorMessage
          // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
          if (e.messages) {
            // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
            errorMessage = `${e.messages.message[0].code} - ${e.messages.message[0].text}`
            dispatch(setError(errorMessage, bookingId))
            forceLoading(false)
          }
        } finally {
          if (adyen) forceLoading(false)
        }
      },
      [dispatch, selectedPatient, bookingId, forceLoading, dispatchData, adyen, setMethodCardError],
    )
    const onCloseAddPopUp = useCallback(() => {
      setShowAddPopUp(false)
      if (cardsList.length) onViewCards(true)
      unlockScroll()
    }, [cardsList.length, onViewCards, unlockScroll])
    if (!show) {
      return null
    }
    return (
      <div className='review-book-container'>
        {showCardsList ?
          <ViewAllCards
            cards={cardsList}
            addPaymentClick={onAddPaymentClick}
            viewAllCards={onViewCards}
            selectCard={onSelectCard}
          />
        : null}
        {showAddPopUp ?
          <div className='review-book-card-pop-up-container'>
            <AddCardPopUp
              ref={addCardRef}
              onClosePopUp={onCloseAddPopUp}
              popUpHeaderName={text.ADD_PAYMENT_METHOD}
              popUpPrimaryBtnText={text.ADD_METHOD}
              userAddress={selectedPatient.Address}
              paymentKeys={paymentKeys}
              creditCardsList={cards || []}
              setPaymentError={onSetPaymentError}
              setPaymentLoading={forceLoading}
              getUserFriendlyMessage={onGetUserFriendlyMessage}
              addCreditCard={onAddCreditCard}
              isOnline={isOnline}
              googleAPIKey={env.googleAPIKey}
              AdyenCardForm={adyen?.AdyenCardForm}
            />
          </div>
        : null}
        {showRescheduleSuccessPopup ?
          <div className='reschedule-success-popup'>
            <PopUp
              content={
                <>
                  <img src={successIcon} alt='Success' className='popup-success-img' />
                  <span className='popup-message'>{text.VISIT_RESCHEDULED_SUCCESS}</span>
                </>
              }
            />
          </div>
        : null}

        <VisitSummary
          fullName={isReschedulePage ? patientFullNameInitial : selectedPatient.fullName}
          dob={isReschedulePage ? dobTextInitial : selectedPatient.dobAge}
          phoneNumber={
            isReschedulePage ? `+${phoneCountryCodeInitial} ${phoneNumberTextInitial}` : selectedPatient.phoneNumber
          }
          email={isReschedulePage ? emailTextInitial : selectedPatient.Email}
          address={isReschedulePage ? addressTextInitial : selectedPatient.address}
          dateTime={isReschedulePage ? visitInfo.providerInfo.dateTime : visitInfo.date}
          providerName={isReschedulePage ? visitInfo.providerInfo.providerName : visitInfo.providerName}
          visitType={visitInfo.visitType}
          visitMethod={visitInfo.method}
          bookingState={visitInfo.state}
          timeZone={timeZone}
          zoneAbbrString={zoneAbbrString}
          isReschedulePage={isReschedulePage}
          selectedOption={selectedOption}
          setSelectedOption={setSelectedOption}
          patientId={selectedPatient?.PatientId}
        />
        {!isReschedulePage && (
          <Payment
            creditAmount={creditAmount}
            card={paymentCard}
            viewCards={onViewCards}
            addPaymentClick={onAddPaymentClick}
            // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
            selectCard={onSelectCard}
            price={visitInfo.price}
            setPrice={setPrice}
            methodError={methodError}
            priceError={priceError}
          />
        )}
      </div>
    )
  },
)
